import { render, staticRenderFns } from "./LoginWebComponent.vue?vue&type=template&id=7b0a81b2"
import script from "./LoginWebComponent.vue?vue&type=script&lang=js"
export * from "./LoginWebComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports